import React from 'react';

import { DateTime } from 'luxon';

import { dateTimeFormat } from 'src/lib/timeUtils';

import { CallSessionEventsList } from './CallSessionEventsList';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CallSession } from '@ragu-components/ord-types';

const CallSessionsList = React.lazy(async () => import('./CallSessionsList'));

export const callSessionsResource: OrdResourceProps = {
  key: 'call_sessions',
  name: 'call_sessions',
  list: <CallSessionsList />,
  edit: <CallSessionEventsList />,
  options: {},
  recordRepresentation: (record: CallSession): string =>
    `${record.caller_id_name ?? ''} ${
      record.creation_time !== undefined && record.creation_time !== null
        ? DateTime.fromISO(record.creation_time).toFormat(dateTimeFormat)
        : ''
    }`,
};
